(() => {
  const ROOT_SELECTOR = '.product__app';
  const TARGET = '[data-mw-option-accumulated-title]';
  const DEBUG = false;

  const getKeyFromTitleEl = (el) => {
    const textNode = [...el.childNodes].find(n => n.nodeType === Node.TEXT_NODE);
    return (textNode?.nodeValue || '')
      .replace(/\u00A0/g, ' ')
      .trim()
      .replace(/^"+|"+$/g, '');
  };

  const renderFinishData = (finish) => `
    <div>Brand: ${finish.brand}</div>
    <div>Name: ${finish.name}</div>
    <div>Color Code: ${finish.colorCode}</div>
    <a href="${finish.orderSample}" target="_blank" rel="noopener" style="color:#BEA639;">Order Sample</a>
  `;

  const renderInsertData = (insert) => `
    <div>Price: +$${insert.price}</div>
    <div>Brand: ${insert.brand}</div>
    <div>Model: ${insert.model}</div>
    <div>CFM: ${insert.cfm}</div>
    <div>${insert.convertible ? "Convertible to Ductless" : "Not Convertible to Ductless"}</div>
    <div>Duct Size: ${insert.ductSize}</div>
  `;

  const updateTitles = (root) => {
    if (DEBUG) console.debug('[updateTitles]', new Date().toISOString());

    root.querySelectorAll(TARGET).forEach((el) => {
      const key = getKeyFromTitleEl(el);
      if (!key) return;

      const finishData = window.FINISHES_DATA?.[key];
      const insertData = window.INSERTS_DATA?.[key];

      const renderData = finishData
        ? renderFinishData(finishData)
        : insertData
        ? renderInsertData(insertData)
        : null;

      if (!renderData) return;

      el.querySelector('.mw-option__price')?.remove();
      el.innerHTML = renderData;
    });
  };

  const observeRoot = (root) => {
    let queued = false;

    const queueUpdate = () => {
      if (queued) return;
      queued = true;

      requestAnimationFrame(() => {
        queued = false;
        updateTitles(root);
      });
    };

    queueUpdate();

    new MutationObserver(queueUpdate).observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  const root = document.querySelector(ROOT_SELECTOR);
  if (root) return observeRoot(root);

  new MutationObserver((_, obs) => {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    obs.disconnect();
    observeRoot(root);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
